import * as ApiUrls from "./ApiUrl.News";
import { AxiosResponse } from "axios";
import { News } from "../../Model/Dto/News";
import { NewsTypes } from "../../Model/Enum/News";
import { axiosCoreInstance } from "../AxiosCoreInterceptor";

export const NewsService = {
    getNews: (newsType:NewsTypes): Promise<AxiosResponse<News.Response[]>> => axiosCoreInstance.get(`${ApiUrls.GetNews}?newsType=${newsType}`),
}